import { ProductBlockImages } from './product-block-images/product-block-images';

export class ProductBlock {
	private element: HTMLElement;
	private readonly imagesElement: HTMLElement;
	private images: ProductBlockImages;

	constructor(element: HTMLElement) {
		if (!element || window.app.classInstance.get(element)) return;
		this.element = element;
		this.imagesElement = this.element.querySelector('.product-block__images');
		this.init();
	}

	public init = (): void => {
		const isInSlider = Boolean(this.element.closest('.slider-products'));
		const isPointerFine = window.matchMedia('(pointer: fine) or (hover: hover)').matches;
		if (this.imagesElement && (!isInSlider || (isInSlider && isPointerFine))) this.images = new ProductBlockImages(this.imagesElement);
		window.app.classInstance.set(this.element, this);
	};

	public destroy = (): void => {
		if (this.imagesElement) {
			this.images.destroy();
			this.images = null;
		}
		window.app.classInstance.del(this.element, this);
	};

	public reinit = (): void => {
		this.destroy();
		this.init();
	};
}
